import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Creation Date", value: "CREATION_DATE" },
  { label: "Start Date", value: "START_DATE" },
  { label: "Booking Number", value: "ORDER_NUMBER" },
  { label: "Buyer Name", value: "BUYER_COMPANY_NAME"},
  { label: "Supplier Name", value: "SUPPLIER_COMPANY_NAME"},
  { label: "Location Name", value: "LOCATION_NAME"},
  { label: "Frequency", value: "DURATION_TYPE"},
  { label: "Brokered", value: "BROKERED"},
  { label: "State", value: "LOCATION_STATE"},
] as const satisfies Array<{label: string, value: string}>;

export type AdminBookingSortByType = typeof sortByFields[number]['value'];

export interface AdminBookingSortParams extends SortParams {
  sortBy?: AdminBookingSortByType;
  sortDir?: SortDirType
}